// extracted by mini-css-extract-plugin
export var productImage = "_r5-1";
export var viewLink = "_r5-2";
export var wishlistItem = "_r5-0";